let fileInput = {
  init: function(input){
    input.addEventListener('change', function(e){
      const valueField = document.querySelector(input.getAttribute('data-value-field'));
      if (valueField) {
        (valueField as HTMLInputElement).value = e.target.files[0].name;
      }
    });
  }
};

export default fileInput;